import { render, staticRenderFns } from "./NetearCobranzasPage.vue?vue&type=template&id=e839cf4e&scoped=true"
import script from "./NetearCobranzasPage.vue?vue&type=script&lang=js"
export * from "./NetearCobranzasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e839cf4e",
  null
  
)

export default component.exports